import { createSlice } from "@reduxjs/toolkit";
import { ApiRequest } from "src/models/api.request";
import VwLabIzlemeIstemDTO from "src/models/LaboratuvarIzleme/VwLabIzlemeIstemDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { helper } from "src/utils/helper";

export class LaboratuvarIzlemeSearch {
  baslangicTarih: string = helper.startDate();
  bitisTarih: string = helper.endDate();
  basariliGosterme: boolean = true;
  disbarkodEsGosterme: boolean = true;
  entLisDisBarkodNo: string = "";
}

interface LaboratuvarIzlemeState {
  searchModel: LaboratuvarIzlemeSearch,
  open: boolean,
  apiRequest?: ApiRequest<VwLabIzlemeIstemDTO>,
  submitForm: boolean,
  selectedId?: number
}
const LaboratuvarIzlemeSlice = createSlice<LaboratuvarIzlemeState, MapReducerPayloads<LaboratuvarIzlemeState, {
  setState: LaboratuvarIzlemeState,
  setSubmitForm : boolean,
  setSelectedId : number
}>>({
  name: 'LaboratuvarIzlem',
  initialState: {
    searchModel: new LaboratuvarIzlemeSearch(),
    open: false,
    submitForm: false,
    selectedId : 0,
  },
  reducers: {
    setState: (state, action) => action.payload,
    setSubmitForm : (state,action) => {
      state.submitForm = action.payload;
    },
    setSelectedId : (state,action) => {
      state.selectedId = action.payload;
    }
  }
})
export default LaboratuvarIzlemeSlice;